module.exports = __webpack_public_path__ + "798cd1d18e51126bc9492e695149f2d0.svg";